module.exports = __webpack_public_path__ + "static/media/infostudio-logo.4109e22e.png";